<script>
import { EventCardElementMixin } from "%/dynamic-component-editor/standard-components/event-card/event-card-element-mixin";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";
import { mapState } from "pinia";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";

export default {
  name: "EventTitle",
  elementPanelSettings: {
    displayName: "Event Title",
    displayIcon: "text-alt",
    elementGroup: "eventElements",
    elementType: "element",
  },
  extends: UrlElement,
  mixins: [EventCardElementMixin],
  computed: {
    ...mapState(useGeneralStore, ["links"]),
    label() {
      return this.entity.title;
    },
    computedHref() {
      return `${this.links.web}/event/${this.entity.id}`;
    },
  },
};
</script>
